// extracted by mini-css-extract-plugin
module.exports = {"table_header":"ReferralTable_table_header__dCknc","content":"ReferralTable_content__5vbXz","disclaimer":"ReferralTable_disclaimer__u1fwT"};